import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";

export const CookieNotice = () => {
  const [open, setOpen] = useState(() => !getConsent());
  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };
  return (
    <div role="dialog" aria-label="Cookie notice" data-testid="cookie-notice"
      className="fixed inset-x-3 bottom-3 z-40 mx-auto max-w-xl animate-in fade-in slide-in-from-bottom-4 rounded-2xl border border-slate-700 bg-slate-950/90 p-3.5 text-sm text-slate-300 shadow-2xl shadow-black/50 backdrop-blur-xl duration-500 sm:bottom-5 sm:p-5 print:hidden">
      <div className="flex gap-3">
        <span className="hidden h-9 w-9 shrink-0 place-items-center rounded-full bg-indigo-500/15 text-indigo-300 sm:grid"><Cookie className="h-5 w-5" /></span>
        <div className="min-w-0">
          <p className="hidden font-display text-base font-bold text-white sm:block">A quick word about cookies</p>
          <p className="text-xs leading-relaxed sm:mt-1 sm:text-sm">We use essential cookies to keep you signed in. With your OK we also save practice progress and streaks on this device. <Link to="/privacy" data-testid="cookie-privacy-link" className="font-semibold text-indigo-300 underline-offset-2 hover:underline">Privacy Policy</Link></p>
          <div className="mt-2.5 flex flex-wrap gap-2 sm:mt-4">
            <button data-testid="cookie-accept-btn" onClick={() => choose("accepted")} className="rounded-full bg-indigo-500 px-4 py-1.5 text-sm font-bold text-white transition-colors hover:bg-indigo-400 sm:px-5 sm:py-2">Accept</button>
            <button data-testid="cookie-decline-btn" onClick={() => choose("declined")} className="rounded-full border border-slate-600 px-4 py-1.5 text-sm font-semibold text-slate-200 transition-colors hover:bg-slate-800 sm:px-5 sm:py-2">Decline</button>
          </div>
        </div>
      </div>
    </div>
  );
};
